module.exports = __webpack_public_path__ + "img/1541307084.9c543970.jpg";